import { Grid, Input, Segmented, Space, Typography } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type ActiveFilter = "all" | "active" | "inactive";

interface Props {
  title: string;
  searchPlaceholder: string;
  filter: ActiveFilter;
  onFilter(filter: ActiveFilter): void;
  onSearch(search: string): void;
  /** Extra controls on the right, such as the create button. */
  extra?: ReactNode;
}

/** Title, active filter and search of the teacher and staff lists. */
export function ProfileListToolbar({ title, searchPlaceholder, filter, onFilter, onSearch, extra }: Props) {
  const { t } = useTranslation();
  const screens = Grid.useBreakpoint();
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", justifyContent: "space-between" }}>
      <Typography.Title level={3} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
      <Space wrap>
        <Segmented<ActiveFilter>
          value={filter}
          onChange={onFilter}
          options={[
            { value: "all", label: t("person.filter.all") },
            { value: "active", label: t("person.filter.active") },
            { value: "inactive", label: t("person.filter.inactive") },
          ]}
        />
        <Input.Search
          allowClear
          placeholder={searchPlaceholder}
          aria-label={searchPlaceholder}
          style={{ width: screens.md ? 300 : 220 }}
          onSearch={(value) => onSearch(value.trim())}
        />
        {extra}
      </Space>
    </div>
  );
}
